import React, { useRef, useEffect } from 'react';
import gsap from 'gsap';
import * as Start from '../style/intro-style';

export const IntroAnimation: React.FC = () => {
    const containerRef = useRef<HTMLDivElement>(null);
    const animatedLine = useRef<HTMLImageElement>(null);
    const firstText = useRef<HTMLImageElement>(null);
    const secondText = useRef<HTMLImageElement>(null);
    const introText = useRef<HTMLHeadingElement>(null);


    useEffect(() => {
        const tl = gsap.timeline({ defaults: { ease: 'back' } });
        
        // Timeline for intro animation
        tl.to(containerRef.current, { opacity: 1, duration: 0.5 })
            .fromTo(animatedLine.current,
                { x: -300, opacity: 0 },
                { x: 0, opacity: 1, duration: 0.6 },
            )

            .fromTo(firstText.current,
                { x: 300, opacity: 0 },
                { x: 0, opacity: 1, duration: 0.6 },
                "<"
            )

            .fromTo(secondText.current,
                { x: -300, opacity: 0 },
                { x: 0, opacity: 1, duration: 0.6 },
                "<"
            )

            .fromTo(introText.current,
                { y: 180, opacity: 0, scale: 0.8 },
                { y: 0, opacity: 1, scale: 1, duration: 0.8, ease: 'power2.out' },
                ">-0.6"
            );
    }, []);


    return (
        <div ref={containerRef}>
            <Start.DecorativeLine ref={animatedLine} />
  
            <Start.StartIntroH1 ref={firstText}>
                Struktur ger frihet.
            </Start.StartIntroH1>

            <Start.StartIntroH1 ref={secondText}>
                Rätt teknik gör allt enklare.
            </Start.StartIntroH1>
            <Start.StartIntroP ref={introText}>
                Vi gillar att skapa ordning, se helheten och bygga it-lösningar som låter dig fokusera på det du gör bäst.
                <br /> <br />
                Med rätt kompetens och teknik gör vi det komplexa enkelt.
                Vi skapar smarta system som ger dig mer tid, bättre flyt och en
                lösning som håller i längden.
            </Start.StartIntroP>
        </div>
    );
};
